import React from 'react';
import OptimizedImage from '../components/OptimizedImage';

const Gallery = () => {
  const galleryImages = [
    {
      src: "/images/image_of_fajita.jpg",
      alt: "Delicious Sizzling Fajitas",
      title: "Signature Fajitas"
    },
    {
      src: "/images/image_of_nachos.jpg",
      alt: "Loaded Ultimate Nachos",
      title: "Ultimate Nachos"
    },
    {
      src: "/images/medium.jpg",
      alt: "Restaurant Atmosphere",
      title: "Our Atmosphere"
    },
    {
      src: "/images/logo.png",
      alt: "Ultimate Bar & Grill Logo",
      title: "Our Brand"
    }
  ];

  return (
    <div className="min-h-screen pt-20 bg-black">
      <div className="container mx-auto px-4 py-16">
        <h1 className="section-title mb-12">Gallery</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div key={index} className="group relative overflow-hidden rounded-lg bg-gray-800 aspect-square">
              <OptimizedImage
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition-all duration-300 flex items-center justify-center">
                <h3 className="text-white text-xl font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {image.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Gallery Sections */}
        <div className="mt-16">
          <h2 className="text-3xl font-bold text-white text-center mb-8">Food & Drinks</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="col-span-2 row-span-2">
              <OptimizedImage src="/images/image_of_fajita.jpg" alt="Featured Fajitas" className="w-full h-full object-cover rounded-lg hover:opacity-90 transition-opacity" />
            </div>
            <div>
              <OptimizedImage src="/images/image_of_nachos.jpg" alt="Nachos" className="w-full h-48 object-cover rounded-lg hover:opacity-90 transition-opacity" />
            </div>
            <div>
              <OptimizedImage src="/images/medium.jpg" alt="Restaurant Interior" className="w-full h-48 object-cover rounded-lg hover:opacity-90 transition-opacity" />
            </div>
            <div>
              <OptimizedImage src="/images/burger_sandwich.jpg" alt="Delicious Burger" className="w-full h-48 object-cover rounded-lg hover:opacity-90 transition-opacity" />
            </div>
            <div>
              <OptimizedImage src="/images/chicken_sandwich.jpg" alt="Chicken Sandwich" className="w-full h-48 object-cover rounded-lg hover:opacity-90 transition-opacity" />
            </div>
          </div>
        </div>

        {/* Bar & Drinks Section */}
        <div className="mt-16">
          <h2 className="text-3xl font-bold text-white text-center mb-8">Bar & Drinks</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <div>
              <OptimizedImage src="/images/bar.jpg" alt="Our Bar" className="w-full h-48 object-cover rounded-lg hover:opacity-90 transition-opacity" />
            </div>
            <div>
              <OptimizedImage src="/images/lemon_drop_margahrita.jpg" alt="Lemon Drop Margarita" className="w-full h-48 object-cover rounded-lg hover:opacity-90 transition-opacity" />
            </div>
            <div>
              <OptimizedImage src="/images/on_tap.jpg" alt="Beers on Tap" className="w-full h-48 object-cover rounded-lg hover:opacity-90 transition-opacity" />
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Ready to Experience Ultimate Bar & Grill?</h2>
          <p className="text-gray-200 mb-8">Come visit us and taste what makes us special!</p>
          <div className="space-y-4 md:space-y-0 md:space-x-4 md:flex md:justify-center">
            <a href="/menu" className="btn-primary inline-block">
              View Our Menu
            </a>
            <a href="tel:+17047999771" className="btn-secondary inline-block">
              Call to Order
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
